import React from 'react';
import { ClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  tone?: 'light' | 'dark';
};
export function Countdown({
  tone = 'light'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    label: 'Hours',
    value: hours
  }, {
    label: 'Minutes',
    value: minutes
  }, {
    label: 'Seconds',
    value: seconds
  }];
  const isDark = tone === 'dark';
  return <div className="flex w-full flex-col items-center" role="timer" aria-label={`Offer time remaining ${hours}:${minutes}:${seconds}`} data-id="element-20" data-mp="3c48rwny8tbj1">
      <p className={`flex items-center gap-1.5 font-display text-xs font-extrabold uppercase tracking-wide ${isDark ? 'text-gold' : 'text-alert'}`} data-id="element-21" data-mp="324hvggq4gmgb">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-22" data-mp="10clbcipw249x" />
        Promotional price reserved for
      </p>
      <div className="mt-2.5 flex items-start gap-2" data-id="element-23" data-mp="15by57nf6gbm0">
        {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-24" data-mp="y0wvbnkxs0lj" data-mpi={i}>
            {i > 0 && <span className={`pt-2 font-display text-3xl font-black ${isDark ? 'text-white/60' : 'text-navy-900/40'}`} aria-hidden="true" data-id="element-25" data-mp="xz3oa76eved0">
                :
              </span>}
            <div className="flex flex-col items-center" data-id="element-26" data-mp="12rmyqv9sxtdl">
              <span className={`min-w-[68px] rounded-xl px-2 py-2 text-center font-display text-[34px] font-black leading-none tabular-nums ${isDark ? 'bg-white text-navy-950' : 'bg-navy-950 text-white'}`} data-id="element-27" data-mp="12tznpsdz9405">
                {unit.value}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wide ${isDark ? 'text-white/70' : 'text-ink/55'}`} data-id="element-28" data-mp="k1nceg5cisdv">
                {unit.label}
              </span>
            </div>
          </React.Fragment>)}
      </div>
    </div>;
}